
import { Options, Vue } from "vue-class-component";
@Options({
  watch: {
    "$route.name": {
      handler(routeName: string) {
        if (routeName === "kulioner-merchant-tab-cycle") {
          this.$router.push({
            name: "kulioner-merchant-tab-cycle-processed",
            params: { id: this.$route.params.id }
          });
        }
      },
      immediate: true
    }
  }
})
class MerchantTabCycle extends Vue {
  mounted() {
    this.$router.push({
      name: "kulioner-merchant-tab-cycle-processed",
      params: { id: this.$route.params.id }
    });
  }

}
export default MerchantTabCycle;
